// extracted by mini-css-extract-plugin
export default {"contentContainer":"CreateFormContent_contentContainer__Lit0H"};